export default __webpack_public_path__ + "static/media/Reloj.0506b754.svg";